export enum FilesOrderingAllEnum {
  Name = 'Name',
  Created = 'Created',
}
